import {
  CreativeTemplateFeature,
  CreativeTemplateSource,
  CreativeTemplateType,
} from './creativeTemplates.types';
import iconsObj from '../../assets/icons/iconsObj';

const idPrefix = 'T';

const FORMAT_QUERY_KEY = 'format';

const featuresIcons: Record<CreativeTemplateFeature, string> = {
  [CreativeTemplateFeature.Xenon]: '',
  [CreativeTemplateFeature.Location]: iconsObj.decisionTree.store,
  [CreativeTemplateFeature.Feed]: iconsObj.decisionTree.products,
  [CreativeTemplateFeature.PromoSlide]: '',
  [CreativeTemplateFeature.Weather]: iconsObj.premiumServices.sun,
  [CreativeTemplateFeature.Video]: iconsObj.videoCamera,
  [CreativeTemplateFeature.Content]: iconsObj.premiumServices.content,
};

const templateMediaTypes: number[] = [CreativeTemplateType.VideoAds, CreativeTemplateType.ImageAds];
const templateVideoSupportedSources: CreativeTemplateSource[] = [
  CreativeTemplateSource.AfterEffect,
  CreativeTemplateSource.ClinchSDK,
];

const duplicationSupportedSources: CreativeTemplateSource[] = [
  CreativeTemplateSource.AfterEffect,
  CreativeTemplateSource.ClinchSDK,
  CreativeTemplateSource.AdBuilder,
];

const mappableTemplateSources = [CreativeTemplateSource.AdBuilder];

const templateSourceUiName: Record<CreativeTemplateSource, string> = {
  [CreativeTemplateSource.AfterEffect]: 'Jet Mapping',
  [CreativeTemplateSource.ClinchSDK]: 'Custom Code',
  [CreativeTemplateSource.AdBuilder]: 'Ad Builder',
};

const unsupportedWeatherTypes: CreativeTemplateType[] = [CreativeTemplateType.VideoAds];

const supportedPlayerActionsTypes: CreativeTemplateType[] = [
  CreativeTemplateType.DisplayAds,
  CreativeTemplateType.InBannerVideoAds,
];

const videoSupportedTemplateTypes: CreativeTemplateType[] = [
  CreativeTemplateType.VideoAds,
  CreativeTemplateType.InteractiveVideoAds,
  CreativeTemplateType.InBannerVideoAds,
];

const videoPoweredTemplateTypes: CreativeTemplateType[] = [
  CreativeTemplateType.VideoAds,
  CreativeTemplateType.InteractiveVideoAds,
];

const MAX_TEMPLATE_NAME_LENGTH = 100;

export {
  idPrefix,
  featuresIcons,
  templateMediaTypes,
  mappableTemplateSources,
  templateVideoSupportedSources,
  templateSourceUiName,
  duplicationSupportedSources,
  MAX_TEMPLATE_NAME_LENGTH,
  unsupportedWeatherTypes,
  supportedPlayerActionsTypes,
  videoSupportedTemplateTypes,
  videoPoweredTemplateTypes,
  FORMAT_QUERY_KEY,
};
